import React, {useContext, useEffect} from "react";
import { UserGames } from "../Context/UserGames";
import { useParams } from "react-router";
import { Input } from "antd";

const CreateDataGames = () => {
   
    let {Id} = useParams()
    const {functions, input}= useContext (UserGames)
    
    const {getDataById, handleChange, handleSubmit} = functions

    useEffect (() => {
        if (Id !== undefined) {

            getDataById(Id)
        }
    }, [])

    console.log(Id)


    return (
    <>

    <div className="form-buah">
    <h1 style={{color: "white", fontSize: "35px", marginTop:"40px", textAlign:"center", fontWeight:"bold"}}>Create Your Data Games Here!</h1>
    <form onSubmit={handleSubmit}>
      <label htmlFor="fname">Name:</label>
      <Input required onChange={handleChange} value={input.name} type="text" id="fname" name="name" placeholder="Games's Name "/>
      <label htmlFor="lname">Genre:</label>
      <Input required onChange={handleChange} value={input.genre} type="text" id="lname" name="genre" placeholder="Genre.."/>
      <label htmlFor="lname">Platform:</label>
      <Input required onChange={handleChange} value={input.platform} type="text" id="lname" name="platform" placeholder="Platform.."/>
      <label htmlFor="lname">Release:</label>
      <Input required onChange={handleChange} value={input.release} type="number" id="lname" name="release" />
      <label htmlFor="lname">Image URL:</label>
      <Input required onChange={handleChange} value={input.image_url} type="text" id="lname" name="image_url"placeholder="url..." />
      <label htmlFor="lname">Single Player</label>
      <input onChange={handleChange} style={{marginLeft: "0px"}} type="checkbox" checked={input.singlePlayer} id="lname" name="singlePlayer"/>
      <label htmlFor="lname">Multi Player</label>
      <input onChange={handleChange} style={{marginLeft: "0px"}} type="checkbox" checked={input.multiplayer} id="lname" name="multiplayer"/>
      
      <Input type="submit" value="Submit"/>
    </form>
  </div>
 

</>
    )
}

export default CreateDataGames